/**
 * Handles add to bag button for PLP's (Supported only by favorites and BI best sellers)
 *
 * @module plpAddToBag
 */

import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import { addToBag as pdpAddToBag } from '../pdp/add-to-bag';

export const PLUGIN_NAME = 'plpAddToBag';

const addToBag = ($el) => {
  const isOneSize = $el.data("oneSize");
  let code = $el.data('code');
  let size = $el.data('size');

  const swatchName = 'color_' + code;
  const radioBtn = $('input[name=\'' + swatchName + '\']:checked');

  if (radioBtn && radioBtn.length) {
    code = radioBtn.closest('.js-plp-swatch').data('code');
  }

  if (isOneSize) {
    size = 'all';
  } else if (!size) {
    const $sizeEl = $el.parent().find('.js-select-size');
    $sizeEl.data('addToBag', true);
    $sizeEl.data('code', code);

    const $selectSizeTrigger = $sizeEl.find('.js-select-size-trigger');
    $selectSizeTrigger.click();
  }

  if (size) {
    pdpAddToBag(code, size);
    $el.data('size', ''); // reset size so dropdown can be opened again
  }
}

/**
 * Add To Bag Functionality for PLP (Supported on Favorites/BI Best Seller Page atm)
 *
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
export default function plpAddToBag(el, options = {}) {
  const $el = $(el);

  $el.on('click', (e) => {
    e.preventDefault();
    addToBag($el);
  });
}

registerJQueryPlugin(PLUGIN_NAME, plpAddToBag);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/add-to-bag.js